import { I18n as awsAmplifyI18n } from 'aws-amplify/utils'

import { Lang } from '../types'

/**
 * We are using aws-amplify for authentication.
 * It uses its own i18n provider, we set the dictionary here for all languages other than English
 * which is provided by defauult.
 * @param lang currentLanguage
 */
export const setI18nForAuth = (lang: Lang) => {
  const dict = {
    'es': {
      'Sign in': 'Inicia sesión en tu cuenta',
      'Sign In': 'Iniciar sesión',
      'Create Account': 'Crear cuenta',
      'Username': 'Email',
      'Enter your Username': 'Ingresa tu email',
      'Enter your username': 'Ingresa tu email',
      'Password': 'Contraseña',
      'Enter your Password': 'Ingresa tu contraseña',
      'Please confirm your Password': 'Por favor confirma tu contraseña',
      'Forgot your password?': '¿Olvidaste tu contraseña?',
      'Incorrect username or password.': 'Email o contraseña incorrectos.',
      'Reset Password': 'Restablecer Contraseña',
      'New Password': 'Nueva contraseña',
      'Confirm Password': 'Repetir contraseña',
      'Send code': 'Enviar codigo',
      'Back to Sign In': 'Volver a iniciar sesión',
      'Code *': 'Código *',
      'Code': 'Código',
      'Submit': 'Enviar',
      'Resend Code': 'Reenviar código',
      'Sending': 'Enviando',
      'Signing in': 'Ingresando',
    }
  }
  awsAmplifyI18n.putVocabularies(dict)
  awsAmplifyI18n.setLanguage(lang)
}
